module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0163.jpg?v=fb828b63";